
import { ACTIONS, URLS, STORAGE } from '../../_config';
import { ActionExtended } from '../../_config/interfaces/interfaces';

export interface UserReducer {
	store: any;
	branchDS: any;
	accessToken: string | null;
	refreshToken: string | null;
	loginCode: string | null;
	isAuthenticated: boolean;
	branchRefreshTimestamp: number | null;
	modules: number[] | null;
	company: { id: number; company_id: string | null; company_name: string; company_logo: string | null } | null;
}

const initialState: UserReducer = {
	store: null,
	branchDS: null,
	accessToken: null,
	refreshToken: null,
	loginCode: null,
	isAuthenticated: false,
	branchRefreshTimestamp: null,
	modules: null,
	company: null,
};


const userReducer = (state = initialState, action: ActionExtended) => {
	switch (action.type) {
		case ACTIONS.USER.LOGIN:
			return {
				...state,
				accessToken: action.payload.accessToken,
				refreshToken: action.payload.refreshToken,
				loginCode: action.payload.loginCode,
				isAuthenticated: true,
				branchDS: null,
				store: null,
			};

		case ACTIONS.STORE.GET_STORE:
			return {
				...state,
				store: action.payload,
				isAuthenticated: true,
			};
		
		case ACTIONS.STORE.GET_BRANCH:
			return {
				...state,
				branchDS: action.payload,
				isAuthenticated: true,
			};

		case ACTIONS.STORE.REFRESH_BRANCHES:
			return {
				...state,
				branchRefreshTimestamp: action.payload,
			};

		case ACTIONS.USER.SET_MODULES:
			return {
				...state,
				modules: action.payload,
			};

		case ACTIONS.USER.SET_COMPANY:
			return {
				...state,
				company: action.payload,
			};

		case ACTIONS.USER.LOGOUT:
			return {
				...state,
				...initialState,
				// user: null,
				// accessToken: null,
				// isAuthenticated: false,
			};
		default:
			return state;
	}
};

export default userReducer;
